import React from 'react';
import GenericModal from 'components/GenericModal';

const ConfirmPrintPDFForTeamsModal = ({ show, onCancel, onConfirm }) => {
  return (
    <GenericModal
      danger
      show={show}
      onCancel={onCancel}
      onConfirm={onConfirm}
      name={'confirm-print-pdf-for-teams'}
      title={'Export Team Results PDF'}
      body={
        <p>
          <b className="text-red01">STOP!!</b> Exporting the "for Team" PDF will disable all ability
          to modify or add additional comments. Only selection committee comments will be available
          to add once this PDF is generated.
        </p>
      }
      cancelButton={'Cancel'}
      confirmButton={'Continue'}
    />
  );
};

export default ConfirmPrintPDFForTeamsModal;
